import type React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import { TranslateHtml } from '@change-corgi/core/react/i18n';

import changeLogo from 'src/assets/changeorg-logo.png';

import type { PreviewEmailPetitionTitleProps } from '../../../../types';

export const PreviewEmailPetitionTitle: React.FC<PreviewEmailPetitionTitleProps> = ({ title, userName }) => {
	return (
		<div className="pb-8">
			<div className="pb-4 text-center">
				<Image src={changeLogo} alt="change.org" width={82} className="h-4" />
			</div>
			<Text as="p" size="small">
				<TranslateHtml
					value="corgi.petition_update.preview_modal.petition_title"
					replacements={{ userPreferredName: userName, petitionTitle: title }}
				/>
			</Text>
		</div>
	);
};
